<template>
  <div class="use-potential-selector">
    <select-create
      v-model="usePotential"
      :options="usePotentialOptions"
      :fields="fields"
      :title="modalTitle"
      :label="selectLabel"
      :make-new-item="makeNewUsePotential"
      :allow-create="true"
      @type="onTyping"
      @save="onSave"
      @dialogOpened="onDialogOpened"
      @cancel="onCancel"
    >
      <div v-if="value" slot-scope="{value: model}" class="create-use-potential-dialog">
        <text-input v-if="model" v-model="model[fields.text]" label="Name" />
      </div>
    </select-create>
  </div>
</template>

<script>

import axios from 'axios'
import {mapGetters} from 'vuex'

import newGuid from 'src/js/helpers/new-guid'

import SelectCreate from '@realestate/components/common/SelectCreate'
import TextInput from '@components/forms/TextInput'

export default {
  components: {
    SelectCreate,
    TextInput
  },

  props: {
    label: String,
    fields: Object,
    value: Object
  },

  data () {
    return {
      usePotentialOptions: []
    }
  },

  computed: {
    ...mapGetters('realEstate', [
      'currentOrgUnit']),

    modalTitle () {
      return 'Nutzungsart erfassen'
    },

    selectLabel () {
      return this.label ? this.label : 'Nutzungspotential'
    },

    usePotential: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {

    makeNewUsePotential (input) {
      return {
        name: input,
        uid: newGuid()
      }
    },

    onTyping (input) {
      this._loadOptions(input)
    },

    onSave (newUsePotential) {
      const usePotential = {
        uid: newUsePotential.value,
        name: newUsePotential.text,
        fkDataOwner: this.currentOrgUnit.uid
      }
      axios.post('RealEstate/Facility/CreatePotentialForUse', usePotential)
    },

    onCancel () {

    },

    onDialogOpened () {
      // ToDo: We need a focus method for inputs
      // this.$refs.firstInput.focus()
    },

    _loadOptions (input) {
      axios.get('RealEstate/Facility/GetPotentialForUseTypes', {params: {entityId: this.currentOrgUnit.uid, query: input}})
        .then(result => {
          this.usePotentialOptions = result.data
        })
    }
  },

  watch: {
    usePotential () {
      this.$emit('input', this.usePotential)
    }
  }
}

</script>

<style lang="scss">
</style>
